const nativeNewsletterFormRegistry = new WeakSet();
const feedbackTimers = new WeakMap();

function bindNativeNewsletterForm(form) {
  if (nativeNewsletterFormRegistry.has(form)) return;

  let handledSuccess = form.classList.contains("success");

  const syncState = () => {
    const isSuccess = form.classList.contains("success");

    if (isSuccess && !handledSuccess) {
      form.reset();

      const previousTimer = feedbackTimers.get(form);
      if (previousTimer) window.clearTimeout(previousTimer);

      feedbackTimers.set(form, window.setTimeout(() => {
        form.classList.remove("success");
        feedbackTimers.delete(form);
      }, 5000));
    }

    handledSuccess = isSuccess;
  };

  const observer = new MutationObserver(syncState);
  observer.observe(form, { attributeFilter: ["class"] });

  form.addEventListener("input", () => {
    if (form.classList.contains("error")) form.classList.remove("error");
  });

  nativeNewsletterFormRegistry.add(form);
}

export default function initNativeNewsletterForms(root = document) {
  root.querySelectorAll("form[data-native-newsletter-form]").forEach(bindNativeNewsletterForm);
}
